import React, { useEffect, useState } from "react";
import { Table, Button, Drawer, Form, Input, Switch, Space, Card } from "antd";
import { formatDate } from "../../components/Customs/dateFormatter";
import { GeneralService } from "../../Services/GeneralService";
import { notify } from "../../components/Customs/NotifyProvider";

import { canCreateModule, canUpdateModule, canDeleteModule } from "../../../utils/permissionUtils";

const MODULE_KEY = "manage_expense";

const ManageVendor = () => {
    const [vendors, setVendors] = useState([]);
    const [open, setOpen] = useState(false);
    const [editingVendor, setEditingVendor] = useState(null);
    const [form] = Form.useForm();
    const [searchText, setSearchText] = useState("");

    const getAllVendor = async () => {
        try {
            const req = await GeneralService.get('vendors');
            const updatedData = req.data.map((item, index) => ({
                ...item,
                si_no: index + 1,
            }));

            setVendors(updatedData);
        } catch (error) {
            console.error(error);

        }
    }

    useEffect(() => {
        getAllVendor();
    }, [])
    // Open Drawer for Add
    const handleAdd = () => {
        setEditingVendor(null);
        form.resetFields();
        setOpen(true);
    };

    const filteredVendors = vendors.filter((vendor) =>
        Object.values(vendor)
            .join(" ")
            .toLowerCase()
            .includes(searchText.toLowerCase())
    );

    // Open Drawer for Edit
    const handleEdit = (record) => {
        setEditingVendor(record);
        form.setFieldsValue(record);
        setOpen(true);
    };

    // Submit Form
    const handleSubmit = async (values) => {
        if (editingVendor) {
            // Update
            const updated = vendors.map((v) =>
                v.key === editingVendor.key ? { ...v, ...values } : v
            );
            setVendors(updated);

            const vendor = { ...values, updated_at: formatDate(), }

            const req = await GeneralService.update("vendors", editingVendor.id, vendor);
            if (req.status) {
                notify.success(req.message)
                getAllVendor()
            } else {
                notify.error(req.message)
            }
            getAllVendor();

            console.log(vendor);

        } else {
            // Add
            const newVendor = {
                ...values,
                created_at: formatDate(),
                updated_at: formatDate(),
            };

            console.log(newVendor); 

            const req = await GeneralService.create("vendors", newVendor);
            if (req.status) {
                notify.success(req.message)
                getAllVendor()
            } else {
                notify.error(req.message)
            }
            getAllVendor();

            setVendors([...vendors, newVendor]);
        }

        setOpen(false);
    };

    const handleDelete = async (record) => {
        console.log(record);
        try {
            const req = await GeneralService.delete('vendors', record.id);
            if (req.status) {
                notify.success(req.message);
                getAllVendor();
            } else {
                notify.error(req.message);
                getAllVendor();
            }
        } catch (error) {
            console.error(error);
        }
    }

    // Table Columns
    const columns = [
        { title: "Si. No.", dataIndex: "si_no", align: 'center' },
        { title: "Name", dataIndex: "name" },
        { title: "Phone", dataIndex: "phone" },
        { title: "Email", dataIndex: "email" },
        { title: "Address", dataIndex: "address" },
        {
            title: "Status",
            dataIndex: "is_active",
            render: (val) => (val ? "Active" : "Inactive"),
        },
        // { title: "Created", dataIndex: "created_at" },
        { title: "Last change", dataIndex: "updated_at" },
        {
            title: "Action",
            render: (_, record) => (
                <Space>
               {canUpdateModule(MODULE_KEY) && (
    <Button type="primary" onClick={() => handleEdit(record)}>
        Edit
    </Button>
)}
{canDeleteModule(MODULE_KEY) && (
    <Button danger onClick={() => handleDelete(record)}>
        Delete
    </Button>
)}
                </Space>
            ),
        },
    ];

    return (
        <Card
            extra={
                <Space>
                    <Input.Search
                        placeholder="Search..."
                        size="large"
                        style={{ width: 350 }}
                        onChange={(e) => setSearchText(e.target.value)}
                    />
                {canCreateModule(MODULE_KEY) && (
    <Button type="primary" onClick={handleAdd} size="large">
        Add Vendor
    </Button>
)}
                </Space>
            }
            title='Vendors'
        >


            <Table columns={columns} dataSource={filteredVendors} />

            <Drawer
                title={editingVendor ? "Edit Vendor" : "Add Vendor"}
                open={open}
                onClose={() => setOpen(false)}
                width={400}
            >
                <Form layout="vertical" form={form} onFinish={handleSubmit}>
                    <Form.Item name="name" label="Name" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>

                    <Form.Item name="phone" label="Phone" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>

                    <Form.Item name="email" label="Email">
                        <Input />
                    </Form.Item>

                    <Form.Item name="address" label="Address">
                        <Input.TextArea />
                    </Form.Item>

                    <Form.Item
                        name="is_active"
                        label="Active"
                        valuePropName="checked"
                    >
                        <Switch />
                    </Form.Item>

                    <Space>
                        <Button onClick={() => setOpen(false)}>Cancel</Button>
                        <Button type="primary" htmlType="submit">
                            {editingVendor ? "Update" : "Create"}
                        </Button>
                    </Space>
                </Form>
            </Drawer>
        </Card>
    );
};

export default ManageVendor;